import imageCompression from 'browser-image-compression';

export interface CompressionOptions {
  maxSizeMB?: number;
  maxWidthOrHeight?: number;
  useWebWorker?: boolean;
}

const DEFAULT_OPTIONS: CompressionOptions = {
  maxSizeMB: 0.5,
  maxWidthOrHeight: 800,
  useWebWorker: true
};

/**
 * Compress an image file before upload to reduce size and avoid loading issues.
 * @param file - The image file to compress
 * @param options - Optional compression options (default: 500KB max, 800px max dimension)
 * @returns Compressed File
 */
export async function compressImage(
  file: File,
  options: CompressionOptions = {}
): Promise<File> {
  const opts = { ...DEFAULT_OPTIONS, ...options };
  return imageCompression(file, {
    maxSizeMB: opts.maxSizeMB ?? 0.5,
    maxWidthOrHeight: opts.maxWidthOrHeight ?? 800,
    useWebWorker: opts.useWebWorker ?? true
  });
}
